export enum WorkScheduleProposalStatusEnum {
  Pending = 0,
  Rejected = 1,
  Accepted = 2,
  NotApproved = 3, // by Administrator
  Approved = 4, // by Administrator
}